import Swiper, { Navigation, Mousewheel } from 'swiper';
import { fetchCollection, fetchRecommendedProducts } from '~js/utils/products-and-collections';

const swiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  modules: [Navigation, Mousewheel],
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
    disabledClass: 'swiper-button-hidden',
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.3787,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
    640: {
      spaceBetween: 32,
      slidesPerView: 2.5,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    1024: {
      spaceBetween: 32,
      slidesPerView: 3,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    1280: {
      spaceBetween: 32,
      slidesPerView: 4,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
};

const productExplorer = (numSlides) => ({
  numSlides: numSlides || 16,
  selectedIdx: 0,
  carouselData: [],

  get selectedProducts() {
    const foundCarousel = this.carouselData[this.selectedIdx];
    const firstNumProducts = foundCarousel?.results?.slice(0, this.numSlides) || [];

    return firstNumProducts;
  },

  get selectedCollectionHandle() {
    return this.carouselData[this.selectedIdx]?.handle;
  },

  get selectedCollectionTitle() {
    return this.carouselData[this.selectedIdx]?.title;
  },

  get selectedCollectionCount() {
    return this.carouselData[this.selectedIdx]?.count;
  },

  get selectedCollectionUrl() {
    return this.carouselData[this.selectedIdx]?.url;
  },

  // TODO: consider not using Searchspring
  /**
   * Fetch carousel data from Searchspring API.
   * - Currently only supports fetching either collections data or recommendations, not both
   * - This could be extended to support some tabs being collections and others being
   *   product recommendations.
   */
  async getCarouselData() {
    let carouselData = [];

    /**
     * Map the swiper element to an object containing data about the carousel.
     */
    const mapSSData = (swiper) => {
      const type = swiper.dataset.type;
      return {
        type,
        results: [],
        ...(type === 'products_by_collection' && {
          handle: swiper.dataset.collectionHandle,
          title: swiper.dataset.collectionTitle,
          url: swiper.dataset.collectionUrl,
          count: swiper.dataset.collectionCount,
        }),
        ...(type === 'product_recommendations' && {
          intent: swiper.dataset.recommendationsIntent,
          productId: swiper.dataset.recommendationsProductId,
        }),
      };
    };

    carouselData = Array.from(this.swiperContentEls).map(mapSSData);

    const productRequests = carouselData.map((entry) =>
      entry.type === 'products_by_collection'
        ? fetchCollection(entry.handle, null, this.numSlides)
        : entry.type === 'product_recommendations'
        ? fetchRecommendedProducts(entry.intent, `gid://shopify/Product/${entry.productId}`)
        : null,
    );
    await Promise.all(productRequests).then((responses) =>
      responses.forEach((response, idx) => {
        carouselData[idx].results = response?.products?.nodes;
      }),
    );
    // fetch collection data for carousels in here.
    return carouselData;
  },

  buildSwipers() {
    // Content setup
    if (this.swiperContentEls) {
      this.swiperContentInstances = Array.from(this.swiperContentEls).map(
        (swiperEl) => new Swiper(swiperEl, swiperConfig),
      );
    }
  },

  async init() {
    this.swiperContentEls = this.$el.querySelectorAll('.swiper');
    this.collectionCountSpan = this.$el.querySelector('#collection_count');
    this.carouselData = await this.getCarouselData();
    this.buildSwipers();
    okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef

    this.$watch('selectedIdx', (newIndex) => {
      const swiperInstance = this.swiperContentInstances[newIndex];
      // update since swiper recommends it after you hide/show it
      // source: https://swiperjs.com/swiper-api#method-swiper-update
      swiperInstance.update();
      okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef
    });
  },
});

export default productExplorer;
